import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Link as LinkBase } from "react-router-dom";
import { getDay, getMonthName, getTime } from "utils/Datetime";

const CALENDAR_LIST = [
  {
    id: "uuid-1",
    name: "Working Dog Tour",
    start: "2024-11-19T14:00:02Z",
    end: "2024-11-19T15:00:02Z",
  },
  {
    id: "uuid-2",
    name: "Alumni Reception at AVMA",
    start: "2024-11-20T14:00:02Z",
    end: "2024-11-20T15:00:02Z",
  },
  {
    id: "uuid-3",
    name: "Penn Vet Shelter Medicine Symposium",
    start: "2024-11-21T14:00:02Z",
    end: "2024-11-21T15:00:02Z",
  },
  {
    id: "uuid-4",
    name: "Penn Annual Conference 2024",
    start: "2024-11-22T14:00:02Z",
    end: "2024-11-22T15:00:02Z",
  },
  {
    id: "uuid-5",
    name: "PVMA Alumni Lunch",
    start: "2024-11-23T14:00:02Z",
    end: "2024-11-23T15:00:02Z",
  },
];

export const Calendar = () => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            Calendar
          </Typography>
          <Link
            sx={{ textDecoration: "none" }}
            component={LinkBase}
            to="/calendar"
          >
            VIEW ALL
          </Link>
        </Box>

        <List>
          {CALENDAR_LIST.map((element) => (
            <ListItem
              key={element.id}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  component={LinkBase}
                  to={`/calendar/${element.id}`}
                >
                  <ChevronRight />
                </IconButton>
              }
            >
              <ListItemIcon>
                <Box>
                  <Typography sx={{ fontSize: "14px", color: "black" }}>
                    {getMonthName(element.start)}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "20px", fontWeight: 600, color: "black" }}
                  >
                    {getDay(element.start)}
                  </Typography>
                </Box>
              </ListItemIcon>
              <ListItemText
                primary={element.name}
                secondary={`${getTime(element.start)} - ${getTime(element.end)}`}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
